import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AtsUtilityService {
	constructor() {}

	/**
	 * Reduces an array of objects to a string array of unique keys and names
	 * @method
	 * @param {Object[]} arr - An array of objecst to reduce
	 * @param {string} arr[].name - A name string on the object
	 * @param {string} arr[].key - The key string on the object
	 * @return {void}
	 */
	public reduceNameKey(arr: { name: string; key: string }[]) {
		return arr.reduce(
			(_arr: string[], item) =>
				item.name !== item.key ? _arr.concat(item.name, item.key) : _arr.concat(item.name),
			[]
		);
	}
}
